exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".text-caption[data-v-e3862abc]{margin-bottom:0}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/shared/type-document-input.vue"],"names":[],"mappings":"AACA,+BACE,eAAiB,CAClB","file":"type-document-input.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.text-caption[data-v-e3862abc] {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e3862abc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/sass-resources-loader/lib/loader.js?{"resources":["/opt/build/repo/src/stylesheets/fonts.scss","/opt/build/repo/src/stylesheets/variables.scss","/opt/build/repo/src/stylesheets/mixins.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/clerkinn/shared/type-document-input.vue
// module id = 967
// module chunks = 2 4 5 20 22